'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardIntegrationCtrl',  require('./dashboardIntegrationCtrl'));
app.directive('integrationCreator', [require('./dashboardIntegrationDirective')]);
app.factory('associatedFormsModal', ['$uibModal', '$q', 'Integration', 'Department', '$translate', require('./associatedFormsModal')]);
app.config(['$stateProvider', require('./dashboardIntegrationConfig')]);
